export let EmbedLogoVisibility = /*#__PURE__*/function (EmbedLogoVisibility) {
  EmbedLogoVisibility["CONTROL_BAR"] = "CONTROL_BAR";
  EmbedLogoVisibility["ALWAYS"] = "ALWAYS";
  return EmbedLogoVisibility;
}({});
//# sourceMappingURL=embed-logo-visibility.js.map